module.exports = __webpack_public_path__ + "static/media/planta1.d2322d34.png";